









import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class ShareButtons extends BaseComponent {

    protected isMobileViewportSize: boolean = false;
    protected mail: string = '';
    protected facebook: string = '';
    protected pinterest: string = '';
    protected sms: string = '';

    protected onWindowResize(): void {
        this.isMobileViewportSize = window.innerWidth < 768;
    }

    protected mounted(): void {
        const href = encodeURIComponent(window.location.href);
        const title = encodeURIComponent(document.title);
        const description = encodeURIComponent(this.getMeta('description'));
        const media = encodeURIComponent(this.getMeta('og:image', 'property'));
        const symb = /iPhone|iPad|iPod/i.test(navigator.userAgent) ? '&' : '?';

        this.mail = `mailto:?subject=${title}&body=${description}`;
        this.facebook = `https://www.facebook.com/sharer/sharer.php?u=${href}`;
        this.pinterest = `https://pinterest.com/pin/create/button/?url=${href}&description=${title}&media=${media}`;
        this.sms = `sms:${symb}body=${title}%20${href}`;

        this.onWindowResize();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
    }

    protected beforeDestroy(): void {
        window.removeEventListener('resize', this.onWindowResize);
    }

    protected getMeta(metaName: string, attribute?: string): string {
        attribute = attribute || 'name';
        const metas: any = document.getElementsByTagName('meta');
        for (const meta of metas) {
            if (meta.getAttribute(attribute) === metaName) {
                return meta.getAttribute('content');
            }
        }
        return '';
    }

    protected open(href: string): void {
        window.open(href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ShareButtons.vue